var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsermanagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 15.375C14.2688 8.37525 3.73125 8.37525 3.375 15.375M11.25 5.625C11.25 6.22174 11.0129 6.79403 10.591 7.21599C10.169 7.63795 9.59674 7.875 9 7.875C8.40326 7.875 7.83097 7.63795 7.40901 7.21599C6.98705 6.79403 6.75 6.22174 6.75 5.625C6.75 5.02826 6.98705 4.45597 7.40901 4.03401C7.83097 3.61205 8.40326 3.375 9 3.375C9.59674 3.375 10.169 3.61205 10.591 4.03401C11.0129 4.45597 11.25 5.02826 11.25 5.625Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermanagement);
export default __webpack_public_path__ + "static/media/usermanagement.9133bbea523ac8c95b6bea08637f7142.svg";
export { ForwardRef as ReactComponent };